import React from "react";
import styled from "styled-components";

import * as Color from "~/Color";
import * as Document from "~/Document";
import * as Layout from "~/Layout";
import { NotApplicable } from "~/NotApplicable";
import * as Typography from "~/Typography";

import { Description } from "..";
import { Image } from "../images/Image";

export function PrintableDocument({
  document,
}: {
  readonly document: Document.Document;
}): JSX.Element {
  const images =
    document.images && document.images.length > 0
      ? document.images.map((image) => image.imageUrl)
      : [];


  // Use a fixed height for Safari
  const dimensions = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
    ? { height: "500px" }
    : {};

  return (
    <>
      <Layout.Block.Component>
        <div>
          <div>
            <Typography.Component large align="left">
              {Document.driverName(document)}
            </Typography.Component>
          </div>
          <HorizontalRule />
        </div>
        <Layout.Flex.Component row justify="stretch" align="flex-start">
          <Layout.Flex.Component
            justify="space-between"
            style={{ width: "50%" }}
          >
            <Title>Images</Title>
            {images && images.length > 0 ? (
              images.map((image, index) => (
                <Layout.Flex.Component bottom key={index}>
                  <Image imageUrl={image} {...dimensions} />
                </Layout.Flex.Component>
              ))
            ) : (
              <div style={{ textAlign: "center" }}>
                <NotApplicable>No images available</NotApplicable>
              </div>
            )}
          </Layout.Flex.Component>
          <Layout.Flex.Component align="flex-start" style={{ width: "50%" }}>
            <Description.Component document={document} />
          </Layout.Flex.Component>
        </Layout.Flex.Component>
      </Layout.Block.Component>
    </>
  );
}

export const Title = styled.div`
  width: 100%;
  text-align: "left";
  font-weight: 500;
  padding-bottom: ${Layout.Block.padding()};
`;

const HorizontalRule = styled.div`
  width: 100%;
  height: 1px;
  margin: 0 0 0.7em 0;
  border-bottom: 1px solid ${Color.veryWhiteGrey()};
`;
